import { Text } from "@ds/react";
import useFormField from "hooks/form/useFormField";

import InputWrapper from ".//InputWrapper";

import * as S from "./RadioButtons.style";

function RadioButtons({
  label,
  options = [],
  validationRef,
  validationRules,
  initialValue = "",
  onChange,
  half,
  ...props
}) {
  const { value, errorMessage, updateValue, validationId } = useFormField({
    initialValue,
    validationRef,
    validationRules,
  });

  const handleChange = (newOption) => {
    updateValue(newOption.id);
    onChange?.(newOption.id);
  };

  return (
    <InputWrapper
      label={label}
      error={errorMessage}
      data-validationid={validationId}
      half={half}
      {...props}
    >
      <S.CardRadio>
        {options.map((op) => (
          <S.CheckButton
            className="make-click"
            data-label={op.value?.toLowerCase()}
            type="button"
            key={op.id}
            variant="tertiary-02-md"
            selected={value === op.id}
            onClick={() => handleChange(op)}
          >
            <S.RadioButton selected={op.id === value} />
            <>
              <Text variant="body-02-md">{op.value}</Text>
              {op.icon}
            </>
          </S.CheckButton>
        ))}
      </S.CardRadio>
    </InputWrapper>
  );
}

export default RadioButtons;
